<template>
    <div>

        <CButton
                color="primary"
                variant="outline"
                square
                size="sm"
                @click="goAddNews()"
        >افزودن محصول
        </CButton>
        <CCardBody>
            <CTabs>
                <CTab title="منتشر شده" active>
                    <CDataTable
                            :items="items_active"
                            :fields="fields"
                            column-filter
                            :items-per-page="20"
                            hover
                            sorter
                            pagination
                    >
                        <template #ردیف="{item,index}">

                            <td>
                                <p class="text-muted">{{index+1}}</p>

                            </td>

                        </template>
                        <template #عنوان="{item}">

                            <td>
                                <p class="text-muted">{{item.title}}</p>

                            </td>

                        </template>

                        <template #توضیحات="{item}">

                            <td>
                                <p class="text-muted">{{item.summary.substring(0,20)+"..."}}</p>

                            </td>

                        </template>
                        <template #کاربر="{item}">

                            <td>
                                <p class="text-muted">{{item.user}}</p>

                            </td>

                        </template>
                      <template #price="{item}">

                        <td>
                          <div style="display: inline-flex;" v-if="item.price.length!=0">
                            <CInput  v-model="item.price[0].price" class="text-muted">{{item.view_count}}</CInput>
                            <CButton size="sm" ourlined color="success" @click="update_product_price(item)"><CIcon name="cil-check"/></CButton>
                          </div>

                        </td>

                      </template>
                        <template #تاریخ="{item}">

                            <td>
                                <p class="text-muted">{{item.date}}</p>

                            </td>

                        </template>
                        <template #نمایش="{item}">

                            <td>
                                <p class="text-muted">{{item.view_count}}</p>

                            </td>

                        </template>


                        <template #تصویر="{item}">


                            <td>
                                <CImg width="50px" height="50px" v-bind:src="item.image"/>
                            </td>

                        </template>
                        <template #موجودی="{item}">


                            <td>
                                <p v-if="item.existence.length>0">{{item.existence[0].total}}</p>
                            </td>

                        </template>

                        <template #عملیات="{item,index}">
                            <td class="py-2">
                                <CButton
                                        color="warning"
                                        variant="outline"
                                        square
                                        size="sm"
                                        @click="editDetails(item,index)"
                                >ویرایش
                                </CButton>
                                <CButton
                                        color="danger"
                                        variant="outline"
                                        square
                                        size="sm"
                                        @click="delete_item_dialog(item)"
                                >حذف
                                </CButton>
                                <CButton
                                        color="warning"
                                        variant="outline"
                                        square
                                        size="sm"
                                        @click="existence_item_dialog(item)"
                                >موجودی
                                </CButton>
                                <CButton
                                        color="success"
                                        variant="outline"
                                        square
                                        size="sm"
                                        @click="open_images(item)"
                                >تصاویر
                                </CButton>

                            </td>
                        </template>


                    </CDataTable>

                </CTab>

                <CTab title="منتشر نشده">
                    <CDataTable
                            :items="items_deactive"
                            :fields="fields"

                            :items-per-page="20"
                            hover
                            sorter
                            pagination
                    >
                        <template #ردیف="{item}">

                            <td>
                                <p class="text-muted">{{item.post_id}}</p>

                            </td>

                        </template>
                        <template #عنوان="{item}">

                            <td>
                                <p class="text-muted">{{item.title}}</p>

                            </td>

                        </template>

                        <template #توضیحات="{item}">

                            <td>
                                <p class="text-muted">{{item.summary.substring(0,20)+"..."}}</p>

                            </td>

                        </template>
                        <template #کاربر="{item}">

                            <td>
                                <p class="text-muted">{{item.user}}</p>

                            </td>

                        </template>
                        <template #تاریخ="{item}">

                            <td>
                                <p class="text-muted">{{item.date}}</p>

                            </td>

                        </template>
                        <template #نمایش="{item}">

                            <td>
                                <p class="text-muted">{{item.view_count}}</p>

                            </td>

                        </template>


                        <template #تصویر="{item}">


                            <td>
                                <CImg width="50px" height="50px" v-bind:src="item.image"/>
                            </td>

                        </template>

                        <template #عملیات="{item,index}">
                            <td class="py-2">
                                <CButton
                                        color="primary"
                                        variant="outline"
                                        square
                                        size="sm"
                                        @click="editDetails(item,index)"
                                >ویرایش
                                </CButton>

                            </td>
                        </template>


                    </CDataTable>

                </CTab>
                <CTab title="حذف شده">
                    <CDataTable
                            :items="items_deleted"
                            :fields="fields"

                            :items-per-page="20"
                            hover
                            sorter
                            pagination
                    >
                        <template #ردیف="{item}">

                            <td>
                                <p class="text-muted">{{item.post_id}}</p>

                            </td>

                        </template>
                        <template #عنوان="{item}">

                            <td>
                                <p class="text-muted">{{item.title}}</p>

                            </td>

                        </template>

                        <template #توضیحات="{item}">

                            <td>
                                <p class="text-muted">{{item.summary.substring(0,20)+"..."}}</p>
                            </td>

                        </template>
                        <template #کاربر="{item}">

                            <td>
                                <p class="text-muted">{{item.user}}</p>

                            </td>

                        </template>
                        <template #تاریخ="{item}">

                            <td>
                                <p class="text-muted">{{item.date}}</p>

                            </td>

                        </template>
                        <template #نمایش="{item}">

                            <td>
                                <p class="text-muted">{{item.view_count}}</p>

                            </td>

                        </template>


                        <template #تصویر="{item}">


                            <td>
                                <CImg width="50px" height="50px" v-bind:src="item.image"/>
                            </td>

                        </template>

                        <template #عملیات="{item,index}">
                            <td class="py-2">
                                <CButton
                                        color="primary"
                                        variant="outline"
                                        square
                                        size="sm"
                                        @click="editDetails(item,index)"
                                >ویرایش
                                </CButton>

                            </td>
                        </template>


                    </CDataTable>

                </CTab>
                <CTab title="کالاهای زودکمک">
                  <CRow>
                    <CCol col="3">
                      <CInput
                        v-model="search_txt"
                        placeholder="جستجو"
                        />
                    </CCol>
                    <CCol col="3">
                     <CButton
                         @click="get_news()"
                     color="primary">جستجو</CButton>
                    </CCol>
                  </CRow>
                    <CDataTable
                            :items="items_zoodkomak"
                            :fields="zood_fields"

                            :items-per-page="20"
                            hover
                            sorter
                            column-filter
                            pagination
                    >
                        <template #row_id="{item,index}">

                            <td>
                                <p class="text-muted">{{index+1}}</p>

                            </td>

                        </template>
                        <template #VitrineProductId="{item}">

                            <td>
                                <p class="text-muted">{{item.VitrineProductId}}</p>

                            </td>

                        </template>
                        <template #عنوان="{item}">

                            <td>
                                <p class="text-muted">{{item.title}}</p>

                            </td>

                        </template>

                        <template #توضیحات="{item}">

                            <td>
                                <p class="text-muted">{{item.summary.substring(0,20)+"..."}}</p>
                            </td>

                        </template>
                        <template #کاربر="{item}">

                            <td>
                                <p class="text-muted">{{item.user}}</p>

                            </td>

                        </template>
                        <template #تاریخ="{item}">

                            <td>
                                <p class="text-muted">{{item.date}}</p>

                            </td>

                        </template>
                        <template #نمایش="{item}">

                            <td>
                                <p class="text-muted">{{item.view_count}}</p>

                            </td>

                        </template>


                        <template #تصویر="{item}">


                            <td>
                                <CImg width="50px" height="50px" v-bind:src="item.image"/>
                            </td>

                        </template>

                        <template #عملیات="{item,index}">
                            <td class="py-2">
                                <CButton
                                        color="primary"
                                        variant="outline"
                                        square
                                        size="sm"
                                        @click="editZoodkomakPro(item,index)"
                                >انتشار محصول
                                </CButton>

                            </td>
                        </template>


                    </CDataTable>

                </CTab>
            </CTabs>
        </CCardBody>


        <CModal
                :show.sync="existence_dialog"
                :no-close-on-backdrop="true"
                :centered="true"
                :title="title"
                size="lg"
                color="dark"
        >
            <CInput v-model="modify_existence_value"
            label="موجودی جدید"
            />
            <template #header>
                <h6 class="modal-title">{{title}}</h6>
                <CButtonClose @click="existence_dialog = false" class="text-white"/>
            </template>
            <template #footer>
                <CButton @click="confirm_existence()"
                         color="danger"
                >تایید
                </CButton>
                <CButton
                        @click="existence_dialog =(false)"
                        color="success"
                >انصراف
                </CButton>
            </template>
        </CModal>
<ImageGalleryModals />
    </div>

</template>

<script>
    import axios from "axios";
    import {bus} from "../../main";
    import CInputCurrency from "../includes/CInputCurrency.vue";
import ImageGalleryModals from "../includes/ImageGalleryModals.vue";
    var items_active = [];
    var items_deactive = [];
    var items_deleted = [];


    export default {
        name: 'Login',
        components: {
          ImageGalleryModals,
          CInputCurrency
            // Use the <ckeditor> component in this view.
            // ckeditor: CKEditor.component
        },
        data() {
            return {
              search_txt:'',
                name: '',
                file: '',
                color: '',
                previewImage: '',
                description: '',
                items_active: [],
                fields: [
                    {key: 'ردیف', _style: 'width:5%'},
                    {key: 'title', label: 'عنوان', _style: 'width:10%'},
                    {key: 'code', label: 'کد', _style: 'width:10%'},
                    {key: 'کاربر', _style: 'width:10%;'},
                    {key: 'تاریخ', _style: 'width:10%;'},
                    {key: 'موجودی', _style: 'width:10%;'},
                    {key: 'price',label:'قیمت', _style: 'width:10%;'},
                    {key: 'عملیات', _style: 'width:10%;'},

                ],
                zood_fields: [
                    {key: 'row_id', label: 'ردیف', _style: 'width:5%'},
                    {key: 'VitrineProductId', label: 'شناسه', _style: 'width:5%'},
                    {key: 'ProductName', label: 'عنوان', _style: 'width:20%'},
                    {key: 'CategoryTitle', label: 'دسته بندی', _style: 'width:20%'},
                    {key: 'عملیات', _style: 'width:10%;'},

                ],
                items_deactive: [],
                items_deleted: [],
                items_zoodkomak: [],
                details: [],
                collapseDuration: 0,
                status_form: 0,
                status_form_existence: 0,
                existence_dialog:false,
                modify_existence_value:0,
              status_form_gallery:0,
              gallery_modal:false,
            }
        }, mounted() {
            console.log("process is " + process.env.VUE_APP_BASE_URL);
            this.get_news();
            bus.$on('delete_confirm', (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.cat_id': function (id) {
                this.get_categories();
            }
        },
        methods: {
          update_product_price(item) {
            var self = this;
            // console.log("route id "+this.$route.params.cat_id);
            var url='/api/admin/update_product_price';

            var formData = new FormData();
            formData.append("product_id",item.post_id)
            formData.append("price",item.price[0].price.replace(/,/g,''))
            axios.post(url,formData, {}).then(function (response) {

              var contents = response.data;
              self.$root.modal_component.show_api_response_modals(response);

            })
                .catch(function (error) {

                });

          },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            editDetails(item, index) {
                this.$router.push({path: "/dashboard/products/edit/" + item.post_id});

            },
            editZoodkomakPro(item, index) {
                this.$router.push({path: `/dashboard/products/edit/${item.ProductId}/${item.VitrineProductId}/${item.ProductName}`});
            },
            go_show_product(item) {
                window.open(process.env.VUE_APP_BASE_URL + "products/" + item.slug, "_blank");

            },
          get_news() {
                var self = this;
                // console.log("route id "+this.$route.params.cat_id);
                var url = '/api/admin/get_products';
                if (this.$route.params.cat_id) {
                    url = '/api/admin/get_products_by_cat';
                }
                var formData = new FormData();
                formData.append("token", localStorage.getItem("token"));
                formData.append("cat_id", this.$route.params.cat_id);
                formData.append("txt", this.search_txt);

                axios.post(url, formData, {}).then(function (response) {

                    var contents = response.data;

                    var all_items = contents.posts_active;

                    self.items_active = all_items.filter(x => x.status == 1).map((item, id) => {
                        return {...item, id}
                    });
                    self.items_deactive = all_items.filter(x => x.status == 2).map((item, id) => {
                        return {...item, id}
                    });
                    self.items_deleted = all_items.filter(x => x.status == 3).map((item, id) => {
                        return {...item, id}
                    });
                    var zood_products = response.data.zood_products.filter(x => !response.data.exist_prosudts.includes(x.VitrineProductId.toString()));
                    self.items_zoodkomak = zood_products.map((item, row_id) => {
                        return {...item, row_id}
                    });
                    console.log("cats is " + self.items_active);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goRegister() {
                this.$router.push({path: 'register'});
            },
          goAddNews() {

                this.$router.push({path: '/dashboard/products/create'});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], 'delete_confirm');

                this.status_form = item.post_id;

            },
          open_images(item){
            this.status_form_gallery = item.post_id;
            this.gallery_modal=true
bus.$emit("open_gallery_dialog",item.post_id)
          },
            existence_item_dialog(item) {

                this.status_form_existence = item.post_id;
                if(item.existence.length>0){
                    this.modify_existence_value = item.existence[0].total;
                }else{
                    this.modify_existence_value = 0
                }
                this.existence_dialog = true
            },
            confirm_existence() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "/api/admin/product/update_existence";


                formData.append('post_id', this.status_form_existence);
                formData.append("token", localStorage.getItem("token"));
                formData.append("existence", this.modify_existence_value);

                axios.post(url, formData, {}).then((res) => {
                    console.log(res);
                    if (res.data.error == 1) {
                        this.$root.modal_component.show_danger_modal('خطا', res.data.msg);

                    } else {
                        this.$root.modal_component.show_success_modal('تایید', res.data.msg);

                    }
                    self.status_form_existence = 0;
self.existence_dialog = false
                    self.get_news();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "/api/admin/product/delete";


                formData.append('post_id', this.status_form);
                formData.append("token", localStorage.getItem("token"));

                axios.post(url, formData, {}).then((res) => {
                    console.log(res);
                    if (res.data.error == 1) {
                        this.$root.modal_component.show_danger_modal('خطا', res.data.msg);

                    } else {
                        this.$root.modal_component.show_success_modal('تایید', res.data.msg);

                    }
                    self.status_form = 0;

                    self.get_news();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            }
        }
    }


</script>
